import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AggregatorRegionDto, BaseResponse, RegionDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { aggregatorRegionsUrl, operatorRegionsUrl } from './regions-api.constant';

@Injectable({
  providedIn: 'root',
})
export class RegionsApiService {
  private readonly http = inject(HttpClient);

  getRegions(): Observable<BaseResponse<RegionDto[]>> {
    return this.http.get<BaseResponse<RegionDto[]>>(operatorRegionsUrl());
  }

  getAggregatorRegions(): Observable<BaseResponse<AggregatorRegionDto[]>> {
    return this.http.get<BaseResponse<AggregatorRegionDto[]>>(aggregatorRegionsUrl());
  }
}
